define( 'templates/site-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            'candidateExternalId' : templateBuilder.sortableHeader('candidateExternalId', 'External ID', 'candidateExternalId'),
            'name' : templateBuilder.sortableHeader('name', 'Name', 'nameCI'),
            'maintenanceName' : templateBuilder.sortableHeader('maintenanceName', 'Maintenance', 'maintenanceInfo.nameCI'),
            'hostName' : templateBuilder.sortableHeader('hostName', 'Host', 'host.nameCI'),
            'tapCount' : templateBuilder.sortableHeader('tapCount', 'Stations', 'tapCount'),
            
            // Basic 
            'status' : templateBuilder.basicHeader('status', 'Status'),
            'subscriptionOrderNumber' : templateBuilder.basicHeader('subscriptionOrderNumber', 'Order number'),
            'subscriptionStart' : templateBuilder.basicHeader('subscriptionStart', 'Primary int subs start'),
            'subscriptionProvider' : templateBuilder.basicHeader('subscriptionProvider', 'Primary con provider'),
            'subscriptionType' : templateBuilder.basicHeader('subscriptionType', 'Primary con type'),
            'subscriptionSimNumber' : templateBuilder.basicHeader('subscriptionSimNumber', 'Primary SIM number'),
            'subscriptionLineNumber' : templateBuilder.basicHeader('subscriptionLineNumber', 'Line number'),
            'maintenanceCostsOfInterventions' : templateBuilder.basicHeader('maintenanceCostsOfInterventions', 'Maintenance cost'),
            'installationCostsOfInterventions' : templateBuilder.basicHeader('installationCostsOfInterventions', 'Installation cost'),
            'searchCostsOfInterventions' : templateBuilder.basicHeader('searchCostsOfInterventions', 'Search cost'),
            'lastConventionStatus' : templateBuilder.basicHeader('lastConventionStatus', 'Convention status'),
            'lastConventionAnnualCost' : templateBuilder.basicHeader('lastConventionAnnualCost', 'Annual cost'),
            'lastConventionDate' : templateBuilder.basicHeader('lastConventionDate', 'Start')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'candidateExternalId' : {
                'nodeType':'td',
                'data' : {
                    'site-id' : '${siteId}',
                    'site-name' : '${siteName}',
                },
                'content': {
                    'nodeType':'a',
                    'data' : {
                        'site-id' : '${siteId}',
                        'site-name' : '${siteName}',
                    },
                    'classes' : ['site_selector'],
                    'href': '${siteUrl}',
                    'content': '${candidateExternalId2Display}'
                }            
            },
            'name' : {
                'nodeType':'td',
                'data' : {
                    'site-id' : '${siteId}',
                    'site-name' : '${siteName}',
                },
                'content': {
                    'nodeType':'a',
                    'data' : {
                        'site-id' : '${siteId}',
                        'site-name' : '${siteName}',
                    },
                    'classes' : ['site_selector'],
                    'href': '${siteUrl}',
                    'content': '${siteName}'
                }            
            },
            'maintenanceName' : templateBuilder.basicNode( '${maintenanceName}' ),
            'hostName' : templateBuilder.basicNode( '${hostName}' ),
            'tapCount' : templateBuilder.basicNode( '${tapCount}' ),
            'status' : templateBuilder.basicNode( '${status2Display}' ),
            'subscriptionOrderNumber' : templateBuilder.basicNode('${subscriptionOrderNumber}'),
            'subscriptionStart' : templateBuilder.basicNode('${subscriptionStart}'),
            'subscriptionProvider' : templateBuilder.linkNode('${subscriptionProviderUrl}', '${subscriptionProvider}'),
            'subscriptionType' : templateBuilder.basicNode('${subscriptionType}'),
            'subscriptionSimNumber' : templateBuilder.basicNode('${subscriptionSimNumber}'),
            'subscriptionLineNumber' : templateBuilder.basicNode('${subscriptionLineNumber}'),
            'maintenanceCostsOfInterventions' : templateBuilder.basicNode('${maintenanceCostsOfInterventions}'),
            'installationCostsOfInterventions' : templateBuilder.basicNode('${installationCostsOfInterventions}'),
            'searchCostsOfInterventions' : templateBuilder.basicNode('${searchCostsOfInterventions}'),
            'lastConventionStatus' : templateBuilder.basicNode('${lastConventionStatus}'),
            'lastConventionAnnualCost' : templateBuilder.basicNode('${lastConventionAnnualCost}'),
            'lastConventionDate' : templateBuilder.basicNode('${lastConventionDate}')
        } // end templates data
    }; // end return
});

